/**
 * @generated SignedSource<<a06623f6d671b2e3beb5f470feb195c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProjectSubmissionStatusEnum = "private" | "public";
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type ProjectSubmissionsField_User$data = {
  readonly projectSubmissions: ReadonlyArray<{
    readonly description: string | null | undefined;
    readonly id: string;
    readonly project: {
      readonly title: string | null | undefined;
    } | null | undefined;
    readonly screenshotUrl: string | null | undefined;
    readonly status: ProjectSubmissionStatusEnum | null | undefined;
    readonly url: string | null | undefined;
  }> | null | undefined;
  readonly self: boolean | null | undefined;
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"user_isMember">;
  readonly " $fragmentType": "ProjectSubmissionsField_User";
};
export type ProjectSubmissionsField_User$key = {
  readonly " $data"?: ProjectSubmissionsField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSubmissionsField_User">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectSubmissionsField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "self",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectSubmission",
      "kind": "LinkedField",
      "name": "projectSubmissions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "screenshotUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Project",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "user_isMember",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMember",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "deeb11dd06bad708753586ff5764509c";

export default node;
